const editor = {
  documents: "מסמכים",
  documentsCount: "מסמכים",
  newDocument: "מסמך חדש",
  searchDocuments: "חפש מסמכים...",
  templates: "תבניות",
  saveAsTemplate: "שמור כתבנית",
  export: "ייצוא",
  import: "ייבוא",
  copyAsMarkdown: "העתק כ-Markdown",
  share: "שיתוף",
  shareDescription: "צור קישור קריאה בלבד לשיתוף המסמך",
  createShareLink: "צור קישור שיתוף",
  copyLink: "העתק קישור",
  revokeLink: "בטל קישור",
  versionHistory: "היסטוריית גרסאות",
  noVersions: "אין גרסאות שמורות עדיין",
  restore: "שחזר",
  duplicate: "שכפל",
  delete: "מחק",
  autoSaved: "נשמר אוטומטית",
  confirmDeleteDoc: "למחוק את המסמך?",
  confirmDeleteDocMessage: "הפעולה לא ניתנת לביטול. כל הגרסאות וקישורי השיתוף יימחקו.",
  editTemplate: "ערוך תבנית",
  deleteTemplate: "מחק תבנית",
  confirmDeleteTemplate: "למחוק את התבנית?",
  confirmDeleteTemplateMessage: "התבנית תימחק לצמיתות.",
  templateDeleted: "התבנית נמחקה",
  templateUpdated: "התבנית עודכנה",
  words: "מילים",
  chars: "תווים",
  minRead: "דק' קריאה",
  lastSaved: "שמירה אחרונה",
  shareExpiry: "תוקף קישור",
  noExpiry: "ללא הגבלה",
  expires24h: "24 שעות",
  expires7d: "7 ימים",
  expires30d: "30 ימים",
  linkExpired: "קישור זה פג תוקף",
  sourceBannerStoryMap: "מפת סיפור",
  sourceBannerBack: "חזרה למפת סיפור",
  breadcrumbStoryMap: "מפת סיפור",
  sourceBannerBookmark: "סימנייה",
  sourceBannerOpenUrl: "פתח כתובת",
  loadingDocuments: "טוען מסמכים...",
  noDocumentsYet: "אין מסמכים עדיין",
  untitled: "ללא כותרת",
  saving: "שומר...",
  saved: "נשמר",
  retrying: "מנסה שוב...",
  saveError: "שגיאה בשמירה",
  conflictMessage: "המסמך עודכן בטאב אחר",
  reload: "טען מחדש",
  offlineSavedLocally: "אופליין — נשמר מקומית",
  menu: "תפריט",
  placeholderSlashMenu: "הקלד / לתפריט בלוקים...",
  placeholderHeading1: "כותרת ראשית",
  placeholderHeading2: "כותרת משנית",
  placeholderHeading3: "כותרת קטנה",
  placeholderHeading: "כותרת",
  placeholderListItem: "פריט ברשימה",
  placeholderTask: "משימה",
  placeholderBlockquote: "ציטוט...",
  placeholderCode: "// כתוב קוד כאן...",
  placeholderToggle: "כותרת מתקפלת...",
  placeholderCallout: "כתוב כאן...",
  timeJustNow: "עכשיו",
  timeSecondsAgo: "לפני {{n}} שנ'",
  timeMinutesAgo: "לפני {{n}} דק'",
  timeHoursAgo: "לפני {{n}} שע'",
  categoryManagement: "ניהול",
  categoryDevelopment: "פיתוח",
  categoryStrategy: "אסטרטגיה",
  categoryGeneral: "כללי",
} as const;
export default editor;
